module.exports = __webpack_public_path__ + "static/thank_you_page-bc44cf22191799dc296aab3c5441e682.svg";